import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MatchingProperty } from 'app/event/models/matching-property';
import { MatchingPropertyAssign } from 'app/event/models/matching-property-assign';
import { PropertyMatch } from 'app/event/models/property-match';
import { MenuStore } from 'app/menus/service/menu.store';
import { ConfirmationModalConfig } from 'app/shared/confirmation-modal/confirmation-modal-config';
import { ConfirmationModalComponent } from 'app/shared/confirmation-modal/confirmation-modal.component';
import { MatchingPropertyService } from 'app/shared/matching-property/matching-property.service';
import { Observable } from 'rxjs/Observable';
import { catchError, finalize, take, tap } from 'rxjs/operators';
import { MatchingCandidate } from './../../models/matching-candidate';
import { Constants } from 'app/shared/constants';

@Component({
  selector: 'pioneer-matching-property-candidate',
  templateUrl: './matching-property-candidate.component.html'
})
export class MatchingPropertyCandidateComponent implements OnInit {

  property: MatchingProperty;

  currentPage: number;

  candidatesForm: FormGroup;

  @ViewChild(ConfirmationModalComponent)
  confirmationModal: ConfirmationModalComponent;

  confirmationModalConfig = new ConfirmationModalConfig();

  constructor(
    private formBuilder: FormBuilder,
    private matchingPropertyService: MatchingPropertyService,
    private router: Router,
    private menuStore: MenuStore,
    private translateService: TranslateService) {
  }

  ngOnInit() {
    this.menuStore.setPageHeader('EVENT.PROPERTY_REVIEW.CANDIDATE_PAGE_TITLE', false);

    this.candidatesForm = this.formBuilder.group({
      'matchingOption': [ null,  ]
    });

    this.matchingPropertyService.selectedProperty$.subscribe(property => {
      this.property = property;
    });

    this.matchingPropertyService.selectedPage$.subscribe(page => {
      this.currentPage = page;
    });

  }

  get matchingOption(): string {
    return this.getFormControlValue('matchingOption');
  }

  private getFormControlValue(name: string): any {
    return this.candidatesForm ? this.candidatesForm.get(name).value : null;
  }

  noOptionSelected(): boolean {
    return !this.matchingOption;
  }

  cancelMatch() {
    this.resetForm();
    this.matchingPropertyService.resetSelectedProperty();
    // this.matchingPropertyService.resetSelectedField();
    this.router.navigate([ '/events/matching/property' ], {
    });
  }

  private resetForm(): void {
    this.candidatesForm = this.formBuilder.group({
      'matchingOption': [ null,  ]
    });
  }

  matchCandidate() {
    const candidate: MatchingCandidate = this.getAssingCandidate(this.matchingOption);
    let propertyAssign = new MatchingPropertyAssign({
      matchingPropertyId: this.property.matchingPropertyId,
      vendorSource: this.property.vendorSource,
      vendorId: this.property.vendorId,
      chain: candidate.chain,
      brand: candidate.brand,
      pid: candidate.pid,
      name: candidate.name
    });

    this.assignCandidate(propertyAssign);
  }

  private getAssingCandidate(candidateId: string): MatchingCandidate {
    let assign: MatchingCandidate = new MatchingCandidate();
    this.property.candidates.forEach(candidate => {
      if (candidate.matchingCandidateId === Number(candidateId)) {
        assign = candidate;
      }
    });

    return assign;
  }

  assignCandidate(property: MatchingPropertyAssign) {
    this.candidatesForm.disable();

    this.matchingPropertyService.assignMatchingCandidate(property).pipe(
      take(1),
      tap(() => {
        this.refreshProperties(this.currentPage);
      }),
      catchError(() => {
        return Observable.of(null);
      }),
      finalize(() => {
        this.candidatesForm.enable();
      })
    ).subscribe();
  }

  private refreshProperties(page: number) {
    this.matchingPropertyService.refreshMatchingProperties(page)
      .pipe(take(1))
      .subscribe(() => {
        this.cancelMatch();
      });
  }

  addNewProperty(): void {
    const propertyAddRequest = this.extractProperty();
    try {
      this.matchingPropertyService.addProperty(propertyAddRequest)
        .pipe(take(1))
        .subscribe( () => {
          this.refreshProperties(this.currentPage);
        });
    } catch (error) {
      Observable.throw(error);
    }
  }

  extractProperty() {
    return new PropertyMatch({
      matchingPropertyId: this.property.matchingPropertyId,
      vendorSource: this.property.vendorSource,
      vendorId: this.property.vendorId,
      name: this.property.name,
      address1: this.property.address1,
      address2: this.property.address2,
      address3: this.property.address3,
      city: this.property.city,
      stateProvinceCode: this.property.stateProvinceCode,
      countryCode: this.property.countryCode,
      postalCode: this.property.postalCode
    });
  }

  confirmBeforeAddProperty(): void {
    // set up the title of the confirmation modal
    const label = 'EVENT.PROPERTY_REVIEW.ADD_PROPERTY_CONFIRMATION_TITLE';
    const confirmLabel = 'EVENT.PROPERTY_REVIEW.CONFIRMATION_ADD';
    const params = {};
    const title = this.translateService.instant(label, params);
    const confirmTitle = this.translateService.instant(confirmLabel);
    this.confirmationModalConfig.title = title;
    this.confirmationModalConfig.confirm = confirmTitle;

    this.confirmationModal.open();
  }

  confirmBeforeAddPropertyHandler(value) {
    if (value) {
      this.addNewProperty();
    }
  }

  isNotProvided(vendorId: string): boolean {
    let searchPattern = new RegExp('^' + Constants.NOT_PROVIDED_VENDOR_ID_PREFIX);
    return searchPattern.test(vendorId);
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/matching-property/matching-property-candicate/matching-property-candidate.component.ts